// extracted by css-extract-rspack-plugin
export default {"fileUploadContainer":"Presenter__fileUploadContainer--QPpZ1","withLinkTabTitle":"Presenter__withLinkTabTitle--bTJrw"};